module.exports = __webpack_public_path__ + "img/psicometricos.8d8a7634.jpg";